// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 空状态样式 */

.empty-state {
  padding: 4rem 2rem;
  text-align: center;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn var(--duration-normal) ease;
}

.empty-content {
  max-width: 600px;
  width: 100%;
}

.empty-icon {
  margin-bottom: 2rem;
}

.empty-content h3 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--gray-800);
  margin-bottom: 1rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.empty-content > p {
  color: var(--gray-600);
  font-size: 1.125rem;
  line-height: 1.6;
  margin-bottom: 3rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.feature-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  border: 1px solid var(--gray-200);
  transition: all var(--duration-normal) ease;
}

.feature-item:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
  background: rgba(255, 255, 255, 0.8);
}

.feature-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: var(--gradient-secondary);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

.feature-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.feature-text strong {
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.25rem;
}

.feature-text span {
  font-size: 0.875rem;
  color: var(--gray-600);
}

.quick-tips {
  background: var(--lemon-50);
  border: 1px solid var(--lemon-200);
  border-radius: 12px;
  padding: 2rem;
  text-align: left;
}

.quick-tips h4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--lemon-800);
  margin-bottom: 1rem;
}

.quick-tips h4 i {
  color: var(--lemon-600);
}

.quick-tips ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-tips li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  color: var(--lemon-700);
  line-height: 1.5;
}

.quick-tips li:last-child {
  margin-bottom: 0;
}

.quick-tips li::before {
  content: '💡';
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .empty-state {
    padding: 3rem 1.5rem;
    min-height: 400px;
  }
  
  .empty-content h3 {
    font-size: 1.5rem;
  }
  
  .empty-content > p {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
  
  .feature-highlights {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .feature-item {
    padding: 1rem;
  }
  
  .feature-icon {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .quick-tips {
    padding: 1.5rem;
  }
  
  .quick-tips h4 {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .empty-state {
    padding: 2rem 1rem;
    min-height: 350px;
  }
  
  .empty-content h3 {
    font-size: 1.25rem;
  }
  
  .feature-item {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }
  
  .feature-text {
    text-align: center;
  }
  
  .quick-tips {
    padding: 1rem;
    text-align: center;
  }
  
  .quick-tips li {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EmptyState.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* 空状态样式 */\n\n.empty-state {\n  padding: 4rem 2rem;\n  text-align: center;\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn var(--duration-normal) ease;\n}\n\n.empty-content {\n  max-width: 600px;\n  width: 100%;\n}\n\n.empty-icon {\n  margin-bottom: 2rem;\n}\n\n.empty-content h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin-bottom: 1rem;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.empty-content > p {\n  color: var(--gray-600);\n  font-size: 1.125rem;\n  line-height: 1.6;\n  margin-bottom: 3rem;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.feature-highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 12px;\n  border: 1px solid var(--gray-200);\n  transition: all var(--duration-normal) ease;\n}\n\n.feature-item:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-lg);\n  background: rgba(255, 255, 255, 0.8);\n}\n\n.feature-icon {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  background: var(--gradient-secondary);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.25rem;\n}\n\n.feature-text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.feature-text strong {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.25rem;\n}\n\n.feature-text span {\n  font-size: 0.875rem;\n  color: var(--gray-600);\n}\n\n.quick-tips {\n  background: var(--lemon-50);\n  border: 1px solid var(--lemon-200);\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: left;\n}\n\n.quick-tips h4 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--lemon-800);\n  margin-bottom: 1rem;\n}\n\n.quick-tips h4 i {\n  color: var(--lemon-600);\n}\n\n.quick-tips ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.quick-tips li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n  color: var(--lemon-700);\n  line-height: 1.5;\n}\n\n.quick-tips li:last-child {\n  margin-bottom: 0;\n}\n\n.quick-tips li::before {\n  content: '💡';\n  font-size: 1rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .empty-state {\n    padding: 3rem 1.5rem;\n    min-height: 400px;\n  }\n  \n  .empty-content h3 {\n    font-size: 1.5rem;\n  }\n  \n  .empty-content > p {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .feature-highlights {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .feature-item {\n    padding: 1rem;\n  }\n  \n  .feature-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n  \n  .quick-tips {\n    padding: 1.5rem;\n  }\n  \n  .quick-tips h4 {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .empty-state {\n    padding: 2rem 1rem;\n    min-height: 350px;\n  }\n  \n  .empty-content h3 {\n    font-size: 1.25rem;\n  }\n  \n  .feature-item {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.75rem;\n  }\n  \n  .feature-text {\n    text-align: center;\n  }\n  \n  .quick-tips {\n    padding: 1rem;\n    text-align: center;\n  }\n  \n  .quick-tips li {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
